import { mdiCheckDecagramOutline } from '@mdi/js'
import { useIntl } from 'react-intl'
import { subscriptionTableMessages } from '../messages'
import {
  HeaderColumnEssentials,
  HeaderColumnEssentialsIcon,
  HeaderColumnEssentialsPrice,
  HeaderColumnFeature,
  HeaderColumnIncluded,
  SubscriptionTableHeaderContainer,
} from './styles'

interface SubscriptionTableHeaderProps {
  isBasicHomePlan: boolean
  price: number
}

function SubscriptionTableHeader({
  isBasicHomePlan,
  price,
}: SubscriptionTableHeaderProps) {
  const { formatMessage } = useIntl()

  return (
    <SubscriptionTableHeaderContainer>
      <HeaderColumnFeature>
        {formatMessage(subscriptionTableMessages.headerTitleFeatures)}
      </HeaderColumnFeature>
      <HeaderColumnIncluded isColored={isBasicHomePlan}>
        {formatMessage(subscriptionTableMessages.headerTitleIncluded)}
      </HeaderColumnIncluded>
      <HeaderColumnEssentials isColored={!isBasicHomePlan}>
        <HeaderColumnEssentialsIcon path={mdiCheckDecagramOutline} />
        {formatMessage(subscriptionTableMessages.headerTitleEssentials)}
        <HeaderColumnEssentialsPrice>
          {price.toString() !== 'NaN' && (
            <>
              ${price}/
              {formatMessage(
                subscriptionTableMessages.headerTitleEssentialsYear
              )}
            </>
          )}
        </HeaderColumnEssentialsPrice>
      </HeaderColumnEssentials>
    </SubscriptionTableHeaderContainer>
  )
}

export default SubscriptionTableHeader
